// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/BarChart/color.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {BarChart} from '@sail/charts';
import {ResizableContainer} from '../common/ResizableContainer';

const sales = [
  {
    date: 'Jan',
    sold: 1,
    product: 'tables',
  },
  {
    date: 'Feb',
    sold: 4,
    product: 'tables',
  },
  {
    date: 'Mar',
    sold: 2,
    product: 'tables',
  },
  {
    date: 'Apr',
    sold: 3,
    product: 'tables',
  },
  {
    date: 'May',
    sold: 2,
    product: 'chairs',
  },
  {
    date: 'Jun',
    sold: 6,
    product: 'chairs',
  },
  {
    date: 'Jul',
    sold: 4,
    product: 'chairs',
  },
  {
    date: 'Aug',
    sold: 1,
    product: 'chairs',
  },
];
export const Color = () => {
  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <BarChart data={sales} x="date" y="sold" color="product" />
    </ResizableContainer>
  );
};
